function getSetor(setor) {

  const setores = {
    pedagogico: "Pedagógico",
    financeiro: "Financeiro",
  };

  const data = setores[setor] || "Secretaria";

  return data

}

export default getSetor;